<!--<div [innerHTML]="htmlView" #output class="html-output" [ngClass]="!isCompactDisplay && hasLineBreak ? '' : 'inline'"></div>-->
<div class="message-body" [ngClass]="{ inline: !isCompactDisplay && hasLineBreak, 'big-emoji': bigEmoji }" *ngIf="syntaxTree && syntaxTree.children && syntaxTree.children.length > 0">
  <app-markdown-viewer-fragment *ngIf="syntaxTree" [token]="syntaxTree"></app-markdown-viewer-fragment>
</div>
<!-- <br *ngIf="!isCompactDisplay && hasLineBreak" /> -->
<app-markdown-file-preview [fileUrl]="fileUrl" *ngFor="let fileUrl of attachedFileUrl"></app-markdown-file-preview>
